<template>
  <div class="service-form">
    <div class="card">
      <div class="title" v-for="(item, index) in services" :key="'service' + index">
        <div class="cloumn">
          <template v-if="item.type != 4">
            <span v-if="item.use != -1">{{item.total - item.use}}</span>
            <span v-if="item.use != -1" class="sub">可使用(次)</span>
            <span class="sub" v-else>已失效</span>
          </template>
          <span class="sub" v-else>
            {{item.use == -1 ?'保护中':'已失效'}}
          </span>
          <div class="bd-lt-bg">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="label ">
          <span>{{item.name}}</span>
          <!--<span class="sub">-->
            <!--已使用{{item.use}}张 共{{item.total}}张-->
          <!--</span>-->
        </div>
      </div>
      <div class="des">
        <div class="servie-process">
          <h3>简单<span>3</span>步，尊享VIP服务</h3>
          <div class="process-des">
            <div class="step">
              <i><img src="../../assets/s-form-tjzl.png"/></i
              ><span>提交资料</span>
            </div>
            <div class="line"></div>
            <div class="step">
              <i><img src="../../assets/call_order.png"/></i
              ><span>等待客服电话联系</span>
            </div>
            <div class="line"></div>
            <div class="step">
              <i><img src="../../assets/s-form-xxmd.png"/></i
              ><span>邮寄维修</span>
            </div>
          </div>
        </div>
        <div class="fill"></div>
      </div>
    </div>
    <div class="sub-form">
      <div class="title">
        提交资料 <span class="sub-title">（需上传三张破损手机照）</span><span class="ps-abs" @click="showImeiDialog = true">如何获取 &gt;</span>
      </div>

      <van-uploader
        class="uploader"
        v-model="fileList"
        :max-count="5" multiple accept="image/*"
		:before-read="beforeRead"
		:max-size="3 * 1024 * 1024" 
		@oversize="onOversize"
      />
    </div>
    <div class="sub-form">
      <div class="title">
        服务地址 <span class="sub-title"></span>
      </div>
      <area-picker :areaCode="areaCode" :areaText="areaText" @confirm="areaPickConfirm" />
      <van-field v-model="address" label="详细地址" placeholder="请输入详细地址" />
    </div>
    <div class="sub-form">
      <div class="title">
        描述问题 <span class="sub-title">（请说明问题机型，颜色，版本等情况）</span>
      </div>
      <van-field
              v-model="desc"
              rows="4"
              type="textarea"
              maxlength="200"
              placeholder="请输入问题"
              autosize
              show-word-limit
              class="gray"
      />
    </div>
    <div class="bottom">
      <div class="agreement" @click="gotoAgreement">查看详细服务条款</div>
      <div class="btn"><y-button @click="submit">提交审核</y-button></div>
    </div>
    <taking-hint-dialog :type="0" v-model="showImeiDialog"></taking-hint-dialog>
    <y-cus-content-dialog
            :closeable="true"
            class="validImeiDialog"
            @buttonClick="validImeiHandle"
            title="在申请服务前请填写如下信息，以便我们更好的为您服务"
            v-model="validApplyStatus">
      <van-form ref="validImeiDialogForm">
        <div class="form-label"><span><em class="warn">*</em>输入imei码（必填）</span><span class="oth" @click="showImeiDialog = true">如何获取 &gt;</span></div>
        <van-field
                :clearable="true"
                v-model="validImeiForm.ImeiCode" maxlength="50"
                :rules="[{ required: true, message: '此项为必填' }]"
        />
        <div class="form-label"><span>输入手机序列号</span><span class="oth" @click="goToViewSN">如何获取 &gt;</span></div>
        <van-field
                :clearable="true"
                v-model="validImeiForm.SerialNumber" maxlength="50"
        />
      </van-form>
    </y-cus-content-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import TakinngHintDialog from "@/components/TakingHintDialog.vue";
Vue.component("taking-hint-dialog", TakinngHintDialog);
import { Uploader, Field,Form } from "vant";
import { httpOpen } from "../../scripts/network";
import AreaPicker from '../../components/AreaPicker.vue';
import * as imageConversion from 'image-conversion';  //引入方法
// import { getAgreementUrl } from '../../scripts/care_agreement';
Vue.use(Uploader);
Vue.use(Field);
Vue.use(Form);
export default {
  components: { AreaPicker },
  name: "ServiceForm",
  data() {
    return {
      id: "",
      applyRecordId: null, // 申请服务记录ID
      careType: 1,
      services: [
        {
          name: "电池更换",
          type: 2,
          total: 0,
          use: 0
        },
        {
          name: "屏幕更换",
          total: 0,
          type: 3,
          use: 0
        },
        {
          name: "延保服务",
          total: 0,
          type: 4,
          use: 0,
          info: "保护中"
        },
          {
              name: "后壳更换",
              total: 0,
              type: 5,
              use: 0
          }
      ],
      fileList: [],
      areaCode:null,
      areaText:null,
      address:null,
      desc: "",
      showImeiDialog:false,
      validApplyStatus:false,
      validImeiForm:{}
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.applyRecordId = this.$route.query.applyId;

      //从缓存中取表单数据
      let validImeiByServiceForm = sessionStorage.getItem('ValidImeiByServiceForm')
      try {
          validImeiByServiceForm = JSON.parse(validImeiByServiceForm)
          if (validImeiByServiceForm){
              this.validImeiForm = {...validImeiByServiceForm}
          }
      }
      catch (e) {
          console.log(e)
      }

      this.loadCardInfo();
      this.loadApplyRecordInfo(this.applyRecordId);
  },
  methods: {
    async submit() {
      if (!this.fileList || this.fileList.length === 0) {
           this.$toast("请上传图片");
          return;
      }

      if (!this.areaCode || !this.address) {
        this.$toast('请选择省市区和填写详细地址');
        return;
      }

      if (!this.desc || this.desc.length < 10) {
        this.$toast("请输入问题描述，最少10个字");
        return;
      }

      try {
        this.$loading.show("正在加载...");

        let fileUris = await this.uploadImage();
        let msg = '';
        if (fileUris.length > 0) {
          let fails = fileUris.filter(u => !u.uri);
          for (let i = 0; i < fails.length; i++) {
            msg += "图片" + (fails[i].index + 1) + ":" + fails.msg;
          }
        } else {
          msg = "上传图片出错"
        }
        if (msg) {
          this.$toast(msg); // 上传图片有失败记录
          return;
        }
        
        let data = {
          CardSysNo: this.id,
          Remarks: this.desc,
          AppendixList: fileUris.map(c =>{
            return { AppendixType: 10, AppendixContent: c.uri } 
          }),
          AreaCode: this.areaCode,
          FullAddress: this.address,
          ImeiCode:this.validImeiForm.ImeiCode,
          SerialNumber:this.validImeiForm.SerialNumber
        };
        let ret = await httpOpen("/WuYouCard/OtherServiceApply", {
          type: "post",
          body: data
        });
        if (ret.Status) {
          this.$toast("提交成功");
          this.$router.push({
            name: "ApplyServiceSuccess",
            params: {
              id: this.id,
              type: this.type
            }
          });
        } else {
          this.$toast(ret.Message || "提交失败");
        }
      } catch (e) {
        this.$loading.hide();
        console.error(e);
      } 
    },
    areaPickConfirm(value){
      this.areaCode = value[value.length -1].Code;
      this.areaText = value.reduce((acc, it)=> acc + it.AreaName, '');
    },
    beforeRead(file) {
		let max = 2;
		return new Promise((resolve, reject) => {
				if (file.size >1024 * 1024 * max) {
					   try{
							imageConversion.compressAccurately(file, 2 * 1024).then(res =>{
							   resolve(res);
							});// 超过2M 进行数据压缩
						}
						catch(ex){
							reject(ex);
						}
				}
				else
				{
					  resolve(file);
				}
		})
    },
	onOversize(){
		this.$toast("图片太大(最大3M)");
	},
    mergeData(datas) {
      const data = datas.toMap(i => i.type);
      this.services.forEach(it => {
        let times = data[it.type.toString()];
        it.use = (times && times.use) || 0;
        it.total = (times && times.total) || 0;
      });
      this.services = this.services.filter(item => item.use < item.total);
    },
    async loadCardInfo() {
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/GetCardInfo", {
          type: "post",
          body: { CardSysNo: this.id }
        });
        if (ret.Status) {
            //如果当前激活卡片没有IMEI码，则需要先完善
            if (!ret.Data.IMEICode) {
                this.validApplyStatus = true
            }
          this.careType = ret.Data.ServiceType;
          let list = [];
          ret.Data.OrderEquityList.forEach(item => {
            let type = parseInt(item.EquityType);
            let service = {
              type: type,
              use: item.UseTotalNum,
              total: item.EquityTotalCount
            };
            list.push(service);
          });
          this.mergeData(list);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    async loadApplyRecordInfo(applyId){
      if(!applyId || applyId <=0) return;

      try {
        const result = await httpOpen("/WuYouCard/ServiceApplyDetail", {
          type: "post",
          body: {
            SysNo: applyId,
          },
        });
        const record = result.Data || {};
        // 绑定申请记录的图片
        //this.fileList = record.AppendDixList ? record.AppendDixList.map((i) => {return { url : i.AppendixContent} }) : [];
        this.areaCode = record.CustomerAreaCode;
        if (record.CustomerArea) {
          this.areaText = record.CustomerArea.ProvinceName + record.CustomerArea.CityName + record.CustomerArea.DistrictName;
        }
        this.address = record.CustomerStreetAddress;
        this.desc = record.CustomerMessage;
      } catch (e) {
        console.error(e);
      }
    },
    dataBase64toBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },
    async uploadImage() {
      if (!this.fileList || this.fileList.length === 0) {
        return;
      }

      // 依次上传图片
      let fileUris = [];
      try {
        for (let i = 0; i < this.fileList.length; i++) {
          if (!this.fileList[i].content) { 
            fileUris.push({ index : i, uri: this.fileList[i].url, msg :''}); // 上次申请记录上传的照片
            continue;
          }

          // 当前重新选择上传的照片
          let img = this.fileList[i].content;
          let formData = new FormData();
          const data = this.dataBase64toBlob(img)
          formData.append("file", data)
          const ret = await httpOpen("/Common/ImageFileUpload", {
            type: "POST",
            timeout: 90000,
            body: formData
          });
          if (ret.Status) {
            fileUris.push({ index : i, uri: ret.Data, msg: ret.Message })
          } else {
            fileUris.push({ index : i, uri: null, msg: ret.Message })
          }
        }
      } catch (e) {
        fileUris = null;
        console.log(e);
      }
      return fileUris;
    },
    async gotoAgreement() {
      // this.$loading.show("请稍等")
      // const url = await getAgreementUrl(this.id,null,this.type)
      // this.$loading.hide()
      // this.goto(url)
      this.goto(`/agreement?id=${this.id}`);
    },
    validImeiHandle(){
        this.$refs.validImeiDialogForm.validate().then(() =>{
            this.validApplyStatus = false
        }).catch(() =>{})
    },
    goToViewSN(){
        if (this.validImeiForm.ImeiCode || this.validImeiForm.SerialNumber) {
            sessionStorage.setItem('ValidImeiByServiceForm',JSON.stringify(this.validImeiForm))
        }
      this.goto('/checksn')
    }
  }
};
</script>

<style lang="less">
.service-form {
  min-height: 100vh;
  background: #efefef;
  font-size: 14px;
  color: black;
  font-weight: 500;
  padding: 12px 12px 60px 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .card {
    display: block;
    box-sizing: border-box;
    .title {
      display: flex;
      flex-direction: row;
      font-size: 14px;
      font-weight: bold;
      background: linear-gradient(360deg,#161616, #000000);
      border-radius: 0px 11px 11px 0px;
      position: relative;
      overflow: hidden;
      &:not(:first-child){
        margin-top: 15px;
      }
      .cloumn {
        display: flex;
        padding: 3% 16px;
        flex-direction: column;
        background: linear-gradient(180deg,#f8ead9, #d0bb9e);
        border-radius: 8px 0px 0px 8px;
        margin:6px 0px 6px 16px;
        text-align: center;
        font-size: 35px;
        width: 30%;
        .sub {
          font-size: 12px;
          margin-top: 4px;
        }
        .left{
          font-size:16px;
          font-weight: 500;
        }
        .bd-lt-bg{
          width: 20px;
          position: absolute;
          top:0;
          left: -12px;
          bottom: 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          span{
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 100%;
            background-color: #efefef;
          }
        }
      }
      .label{
        width: 70%;
        display: flex;
        flex-direction: column;
        color: #fff;
        font-size: 17px;
        background: linear-gradient(270deg,#202020, #424242);
        align-items: center;
        justify-content: center;
        line-height: 2;
        .sub{
          font-size: 12px;
          color: #999;
        }
      }
    }
    .des{
      border-radius: 6px;
      margin-top: 14px;
      .servie-process {
        h3 {
          font-size: 15px;
          font-weight: 600;
          border-radius: 2px;
          padding: 4px 9px;
          margin: 0;
          span{
            color: #DA2B2B;
          }
        }
        .process-des{
          padding: 40px 26px;
          background-color: #fff;
          .step {
            height: 28px;
            display: flex;
            flex-direction: row;
            align-items: center;
            counter-increment: step;
            i,
            img {
              max-width: 36px;
            }
            i {
              margin-right: 16px;
            }
            span {
              font-size: 14px;
              color: black;
              font-weight: 600;
            }
          }
          .line {
            height: 18px;
            width: 7px;
            background: rgba(241,220,197,0.33);
            margin: 10px 0 10px 10px;
          }
          .step::before {
            content: counter(step);
            display: block;
            text-align: center;
            color: #000;
            font-size: 18px;
            margin-right: 26px;
            font-weight: bold;
            background: linear-gradient(180deg,#f4e0c9, #ceab8b);
            width: 24px;
            height: 24px;
            border-radius: 100%;
          }
        }
      }
    }
  }
  .sub-form{
    background-color: #fff;
    border-radius: 6px;
    margin-top: 14px;
    padding: 12px 16px;
    .title{
      font-size: 14px;
      color: #000;
      font-weight: 600;
      margin-bottom: 9px;
      position: relative;
      .sub-title{
        color: #666;
        font-size: 12px;
        font-weight: normal;
      }
      .ps-abs{
        position: absolute;
        right: 0;
        color: #C28954;
        font-size: 14px;
        font-weight: normal;
      }
    }
    .uploader {
      margin-bottom: 18px;
      .van-uploader__upload {
        width: 68px !important;
        height: 68px !important;
        border-radius: 3px !important;
        background: rgba(245, 245, 245, 1) !important;
        border-color: rgba(245, 245, 245, 1) !important;
      }
      .van-uploader__upload-icon {
        font-size: 32px !important;
      }
      .van-uploader__preview-image {
        width: 68px !important;
        height: 68px !important;
      }
    }
  }
  .bottom{
    .agreement {
      font-size: 14px;
      color: #000;
      text-align: center;
      padding: 8px;
    }
    .btn{
      background-color: #fff;
      padding: 10px 20px;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
  .view-agreement {
    font-size: 14px;
    color: #000;
    text-align: center;
    margin-top: 15px;
  }
  .van-field {
    &.gray{
      background: #f5f5f5;
    }
    font-size: 14px;
    border-radius: 4px;
  }
  .validImeiDialog{
    .van-cell{
      padding: 5px 16px;
    }
    .form-label{
      font-size: 13px;
      color: #000;
      margin-bottom: 4px;
      display: flex;
      justify-content: space-between;
      &:not(:first-child){
        margin-top: 10px;
      }
      .warn{
        color: red;
        font-size: 16px;
        margin-right: 5px;
        vertical-align: middle;
      }
      .oth{
        font-size: 12px;
        color: #69380a;
      }
    }
  }
}
</style>